import { Divider, Drawer, IconButton, Typography } from '@mui/material';

import CancelIcon from '@mui/icons-material/Cancel';
import Grid from '@mui/material/Unstable_Grid2';
import LessonComponentService from '../services/LessonComponentService';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';
import { TextComponent } from '../models/LessonComponent';
import styles from '../styles/AnchorSidePanel.module.scss';
import useThemes from '../../shared/hooks/useThemes';

interface AnchorSidePanelProps {
  components: TextComponent[];
  lessonTitle: string;
  goToQuestion: (id: number) => void;
  onClose: () => void;
}

export const AnchorSidePanel = (props: AnchorSidePanelProps) => {
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;

  return (
    <Drawer
      open
      anchor="left"
      onClose={props.onClose}
      PaperProps={{ sx: { width: '370px' } }}
      sx={{ zIndex: '1300' }}
    >
      <Grid container direction="column">
        <Grid container justifyContent="flex-end">
          <IconButton size="small" onClick={props.onClose}>
            <CancelIcon />
          </IconButton>
        </Grid>

        <Grid className={styles.listItemContainer}>
          <Typography variant="h6">{props.lessonTitle}</Typography>
          <Divider />
          <List component="nav">
            {props.components?.map(
              (c) =>
                c.content?.text && (
                  <ListItem
                    key={c.componentkey}
                    button
                    onClick={() => {
                      props.goToQuestion(c.componentkey);
                    }}
                    dense
                    disableGutters
                  >
                    <ListItemText
                      primary={LessonComponentService.cleanAndGetFirst(
                        c.content.text
                      )}
                      primaryTypographyProps={{
                        style: { fontFamily }
                      }}
                      classes={{ primary: styles.listItem }}
                    />
                  </ListItem>
                )
            )}
          </List>
        </Grid>
      </Grid>
    </Drawer>
  );
};
